module.exports = __webpack_public_path__ + "static/media/sangbladet.9e6af7bd.png";